import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AuthService } from 'src/app/services/auth.service';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
  selector: 'app-automatic-points-settings',
  templateUrl: './automatic-points-settings.page.html',
  styleUrls: ['./automatic-points-settings.page.scss'],
})
export class AutomaticPointsSettingsPage implements OnInit {

  playerData: any;

  constructor(
    public modalController: ModalController,
    public authService: AuthService,
    private analyticsService: AnalyticsService,
    private toolsService: ToolsService
  ) {
    this.analyticsService.AnalyticsServiceModalView('automatic-points-settings');

  }

  async ngOnInit() {
    this.playerData = await this.authService.getPlayerFullData(false);
  }

  async automaticRedemptionUpdate(newState) {
    ///Function to activate automatic redemption
    await this.toolsService.showLoader();
    try {
      await this.authService.updateAutoRedemptionWalletData(newState);
    } catch (error) {
      console.error('[automatic-points-settings.page] automaticRedemptionUpdate()', error);
    } finally {
      this.toolsService.showSuccessToast(
        newState ? 'Redención automática activada' : 'Redención automática desactivada'
      );
    }
    await this.toolsService.dismissLoader();
    this.closeModal();
  }

  //Function to close modal
  closeModal() {
    this.modalController.dismiss();
  }


  get showDeactivateButton() {
    if (this.playerData && this.playerData.automatic_redemption_wallet == false) return false;
    return true
  }

  get showActivateButton() {
    if (this.playerData && this.playerData.automatic_redemption_wallet == true) return false;
    return true
  }

  get deactivateText(){
    if (this.playerData && this.playerData.automatic_redemption_wallet == true) return 'Desactivar';
    return 'No activar';
  }

}
